const filters={
    // 时间格式转换
    timeToDate:function(val){
        if(val){
            var date = val.replace('T',' ')
            return date.split('.')[0]
        }else{
            return ''
        }
    },
    // 时间格式转换
    timeChange:function(val){
        var date = val.split('T')[0]
        return date
    }
}
export default filters